import styled from 'styled-components';

import ZIndexLayers from '../../services/ZIndexLayers';
import { ThemeProp } from '../../theme/Themes';

export const Items = styled.div`
  background-color: ${(props: ThemeProp) => props.theme.colors.content.white};
  border-radius: ${(props: ThemeProp) => props.theme.borderRadius};
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c050};
  box-shadow: ${(props: ThemeProp) => props.theme.shadows.menu};
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 0.5rem;
  position: absolute;
  z-index: ${ZIndexLayers.popup};
`;

export const Item = styled.div`
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  white-space: nowrap;
`;

export const ItemContainer = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 2;
  gap: 1rem;
  height: 2.5rem;
  padding: 0 0.5rem;
  justify-content: space-between;
  &:hover {
    background: ${(props: ThemeProp) => props.theme.colors.main.c050};
    border-radius: 6px;
  }
`;

export const ItemText = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
`;

export const ItemDescription = styled(ItemText)`
  color: ${(props: ThemeProp) => props.theme.colors.greyscale.c500};
  font-style: italic;
`;
